import type { CourseId, SemesterId } from '/imports/domain';
import { usePublication } from '/imports/ui/hooks/usePublication';
import type { MessageCount } from './shared';

export const useCourseInboxCount = (props: {
  courseId: CourseId;
  semester: SemesterId;
}): MessageCount => {
  const lastChange = usePublication('messages.getLastForCourse', { method: 'trigger', props });
  const count = usePublication('messages.countUnreadCourseMessages', { method: 'count', props });
  return { count, lastChange };
};
